import { useEffect } from 'react'
import { authenticatedSelector, signOutAction } from '@onhandtech/onhand-fe-shared/lib/firebase'
import { Heading, Link, Text } from '@onhandtech/onhand-toolkit'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

import { getRoutePath } from '../../router/router.utils'

import * as CSS from './not-found.styles'

const NotFound = () => {
  const { formatMessage } = useIntl()
  const authenticated = useSelector(authenticatedSelector)
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    if (pathname === '/' && authenticated) {
      navigate(getRoutePath('CODES'))
    }
  }, [pathname, authenticated, navigate])

  return (
    <CSS.NotFound data-testid="page--404">
      <Text level="large">{formatMessage({ id: 'page.404.title' })}</Text>
      <CSS.Status>
        <Text>{formatMessage({ id: 'page.404.description' })}</Text>
      </CSS.Status>
      <CSS.Status>
        <Text>These are the pages that currently exist (and this site map will go soon too):</Text>
        <ul>
          <li>
            <Link to={getRoutePath('SIGN_IN')}>Sign In</Link>
          </li>
          <li>
            <Link to={getRoutePath('FORGOT_PASSWORD')}>Forgot Password</Link>
          </li>
        </ul>
      </CSS.Status>
      <Heading level="bigNumber">404 -</Heading>
      {authenticated && (
        <CSS.Status>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <Text>You are currently logged in.</Text>
            <div style={{ marginBottom: 2 }}>
              <Link onClick={() => dispatch(signOutAction())}>Sign out</Link>
            </div>
          </div>
        </CSS.Status>
      )}
    </CSS.NotFound>
  )
}

export default NotFound
